module.exports = __webpack_public_path__ + "static/media/polygon-pos.f12fc300.svg";